import { ModalType } from "@/constants/modalConst"

export const useModalStore = defineStore("modal", () => {
  type ModalOptionFunction = () => void

  const isVisible = ref(false)
  const catchModal = ref<ModalType | null>(null)
  const options = ref<ModalOptionFunction>(() => {})
  const currentModal = ref<ModalType | null>(null)

  const resetCatchModal = () => {
    catchModal.value = null
  }

  const resetModal = () => {
    currentModal.value = null
  }

  const closeModal = () => {
    isVisible.value = false
  }

  const openModal = (modalType: ModalType, option?: ModalOptionFunction) => {
    if (currentModal.value === modalType) return
    if (option) options.value = option
    isVisible.value = true

    if (currentModal.value !== null) {
      catchModal.value = modalType
      closeModal()
    } else {
      currentModal.value = modalType
    }
  }

  return {
    openModal,
    closeModal,
    resetModal,
    resetCatchModal,
    currentModal,
    catchModal,
    isVisible,
    options
  }
})

export default useModalStore
